module.exports = __webpack_public_path__ + "img/fzlc2020.cf68b61c.png";